import { Component } from 'react'
import { withRouter } from 'react-router-dom'

class RouterScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    const { location } = this.props
    if (location.pathName !== prevProps.location.pathName) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { children } = this.props
    return children
  }
}

export default withRouter(RouterScrollToTop)
